import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          full_name: string | null;
          date_of_birth: string | null;
          avatar_url: string | null;
          language_preference: string;
          timezone: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          full_name?: string | null;
          date_of_birth?: string | null;
          avatar_url?: string | null;
          language_preference?: string;
          timezone?: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          full_name?: string | null;
          date_of_birth?: string | null;
          avatar_url?: string | null;
          language_preference?: string;
          timezone?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      cycle_logs: {
        Row: {
          id: number;
          user_id: string;
          date: string;
          period_start: boolean;
          flow_level: string | null;
          symptoms: string[] | null;
          mood: string | null;
          notes: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          user_id: string;
          date: string;
          period_start?: boolean;
          flow_level?: string | null;
          symptoms?: string[] | null;
          mood?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          user_id?: string;
          date?: string;
          period_start?: boolean;
          flow_level?: string | null;
          symptoms?: string[] | null;
          mood?: string | null;
          notes?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      doctor_questions: {
        Row: {
          id: number;
          user_id: string;
          category: string;
          question: string;
          language: string;
          status: string;
          response: string | null;
          doctor_id: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          user_id: string;
          category: string;
          question: string;
          language: string;
          status?: string;
          response?: string | null;
          doctor_id?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          user_id?: string;
          category?: string;
          question?: string;
          language?: string;
          status?: string;
          response?: string | null;
          doctor_id?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
      user_preferences: {
        Row: {
          id: number;
          user_id: string;
          notification_period_reminder: boolean;
          notification_ovulation_reminder: boolean;
          notification_doctor_response: boolean;
          cycle_length_average: number;
          period_length_average: number;
          privacy_data_sharing: boolean;
          privacy_analytics: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: number;
          user_id: string;
          notification_period_reminder?: boolean;
          notification_ovulation_reminder?: boolean;
          notification_doctor_response?: boolean;
          cycle_length_average?: number;
          period_length_average?: number;
          privacy_data_sharing?: boolean;
          privacy_analytics?: boolean;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: number;
          user_id?: string;
          notification_period_reminder?: boolean;
          notification_ovulation_reminder?: boolean;
          notification_doctor_response?: boolean;
          cycle_length_average?: number;
          period_length_average?: number;
          privacy_data_sharing?: boolean;
          privacy_analytics?: boolean;
          created_at?: string;
          updated_at?: string;
        };
      };
      cycle_insights: {
        Row: {
          id: number;
          user_id: string;
          insight_type: string;
          insight_data: any;
          generated_at: string;
          is_read: boolean;
          created_at: string;
        };
        Insert: {
          id?: number;
          user_id: string;
          insight_type: string;
          insight_data: any;
          generated_at?: string;
          is_read?: boolean;
          created_at?: string;
        };
        Update: {
          id?: number;
          user_id?: string;
          insight_type?: string;
          insight_data?: any;
          generated_at?: string;
          is_read?: boolean;
          created_at?: string;
        };
      };
    };
  };
};